<template>
  <footer class="py-3"></footer>
</template>

<script>
export default {
  name: "BackendFooter",
};
</script>

<style>
</style>
